<template>
    <g fill="" fill-rule="evenodd">
        <g>
            <g>
                <g>
                    <g transform="translate(-1010 -481) translate(768 457) translate(242 24)">
                        <rect width="55" height="24" fill="#C2CDD7" rx="12"/>
                        <circle cx="12" cy="12" r="7" fill="#FFF"/>
                    </g>
                    <text fill="#FFF" font-family="OpenSans-Bold, Open Sans" font-size="11" font-weight="bold" transform="translate(-1010 -481) translate(768 457) translate(242 24)">
                        <tspan x="25" y="16">Off</tspan>
                    </text>
                </g>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'switcherDisabledAdUnitIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 55 24');
    }
};
</script>
